// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__pOb0O","overallTable":"style__overallTable__XlToy"};